import React from 'react';
import { Footer , Header} from '../index';
import { Link } from 'react-router-dom';
import './club.css';
import ieee from '../../asserts/images/IEEE3.jpg';
import CPU from '../../asserts/images/CPU.jpg';
import ATIA from '../../asserts/images/ATIA.jpg';
import CRI from '../../asserts/images/CRI.jpg';
import ENGLISTICS from '../../asserts/images/ENGLISTICS.jpg';
import MUSIQUE from '../../asserts/images/MUSIQUE2.jpg';



function Club(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
    <Header />
      <div className='containerClub'>
        <div className='bgclub'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'45px'}}className="container-fluid text-white text-center" id='h1club'>Clubs Universitaires</h1>
          <p ><Link className='linkclub' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkclub'
            to="/"> Vie étudiante </Link>  <span>{'>'}</span> <Link className='linkclub'
            to="/">Vie associative</Link><span>{'>'}</span> <Link className='linkclub'
            to="/">Clubs</Link></p></div>
       

      </div>
   
      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB'>
                <img src={ieee}  alt="..."/>
                </div>
                <div>
                <div className="l">
                <a href='https://www.facebook.com/IEEEISIMMSB?mibextid=ZbWKwL'target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
                <a href='https://www.instagram.com/ieee_isimm_sb?igsh=MTljM2l5b21renkxaQ==' target='_blank'><ion-icon name="logo-instagram"></ion-icon></a>
                <a href='https://www.linkedin.com/company/ieee-isimm-sb/' target='_blank'><ion-icon name="logo-linkedin"></ion-icon></a>
                </div>
                </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>IEEE</span><br/><br/>
          IEEE ISIMM SB est une branche étudiante de l'Institut des ingénieurs électriciens et électroniciens (IEEE)
         qui se concentre sur le domaine de l'instrumentation et de la mesure. Il est spécifiquement dédié à la 
         promotion de l’avancement de la théorie et de la pratique de l’instrumentation et de la mesure dans divers
          domaines, tels que l’ingénierie, la science, la médecine et l’industrie.<br/><br/>
        <a href='http://isimm.ieee.tn' target='_blank' style={{textDecoration:'none',color:'#162533'}}>{'> '}Voir site web </a>
       </div>
        </div>
 
     
   
      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB'>
                <img src={ATIA}  alt="..."/>
                </div>
                <div>
                <div className="l">
                <a href='https://www.facebook.com/profile.php?id=100086600541050&mibextid=ZbWKwL'target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
                <a href='https://www.instagram.com/atia_club_isimm/' target='_blank'><ion-icon name="logo-instagram"></ion-icon></a>
                <a href='https://www.linkedin.com/company/atia-isimm/' target='_blank'><ion-icon name="logo-linkedin"></ion-icon></a>
                </div>
                </div>
            </div>
            <div className='PRESCLUB' style={{paddingBottom:'40px'}}>
            <span className='NOMCLUB'>ATIA</span><br/><br/>
            L’Association Tunisienne pour l’Intelligence Artificielle, ATIA,
         vient en réponse aux besoins changeants d’aujourd’hui et aux technologies 
         en rapide évolution nécessitant l’intelligence artificielle pour fournir des outils et solutions 
         d’aide à la décision permettant de mieux comprendre, prévoir et influencer la prise de décision
          humaine de grands groupes et populations. L’ATIA vise à promouvoir le rôle 
        de levier socio-économique de l’Intelligence Artificielle au profit de la société et des individus.<br/><br/>
        <a href='http://atia.org.tn/' target='_blank' style={{textDecoration:'none',color:'#162533'}}> {'> '}Voir site web </a>
       </div>
        </div>

      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB'>
                <img src={CPU}  alt="CPU"/>
                </div>
                <div>
                <div className="l">
                <a href='https://www.facebook.com/CPU.ISIMM?mibextid=ZbWKwL' target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
                <a href='https://www.instagram.com/cpu.isimm?igsh=cTQ5N2J4Z24yMXdm' target='_blank'><ion-icon name="logo-instagram"></ion-icon></a>
                <a href='https://www.linkedin.com/in/cpu-isimm-068816218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><ion-icon name="logo-linkedin"></ion-icon></a>
                </div>
                </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>CPU</span><br/><br/>
            CPU club qui offre aux étudiants une immersion pratique dans le monde de la technologie et
        de l'ingénierie. En concevant, construisant et programmant des robots, 
        les membres développent des compétences en résolution de problèmes et en 
        collaboration. De la conception à la compétition, ce club stimulant prépare 
        les étudiants à relever les défis technologiques du monde réel et à devenir les innovateurs de demain.<br/><br/>
       </div>
        </div>


      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB' >
                <img src={CRI}  alt="CRI"/>
                </div>
                <div>
                <div className="l">
                <a href='https://www.facebook.com/C.R.ISIMM?mibextid=ZbWKwL' target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
               <a href='#'><ion-icon name="logo-instagram"></ion-icon></a>
               <a href='https://www.linkedin.com/in/club-robotique-isimm-cri-721b81195?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><ion-icon name="logo-linkedin"></ion-icon></a>
              </div>
            </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>CRI</span><br/><br/>
            CRI club qui offre aux étudiants une immersion pratique dans le monde de la technologie et
        de l'ingénierie. En concevant, construisant et programmant des robots, 
        les membres développent des compétences en résolution de problèmes et en 
        collaboration. De la conception à la compétition, ce club stimulant prépare 
        les étudiants à relever les défis technologiques du monde réel et à devenir les innovateurs de demain.
<br/><br/>
       </div>
        </div>

   
      <div className="containerclub1">
            <div className='CLUB'>
                <div className='IMAGECLUB'>
                <img src={ENGLISTICS} alt="ENGLISTICS"/>
                </div>
                <div>
                <div className="l"style={{marginTop:'0px'}}>
                <a href='https://www.facebook.com/Englistics.isimm?mibextid=ZbWKwL'target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
                <a href='#'><ion-icon name="logo-instagram"></ion-icon></a>
                 <a href='#'><ion-icon name="logo-linkedin"></ion-icon></a>
                    </div>
                </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>ENGLISTICS</span><br/><br/>
       Englistics est bien plus qu'un simple club ; il représente une véritable opportunité pour les étudiants
        d'affiner leurs compétences en anglais et en communication tout en s'immergeant dans un environnement 
        ludique et stimulant. En effet, ce club va au-delà des salles de classe traditionnelles en offrant 
        une plateforme dynamique où les membres peuvent pratiquer la langue de manière pratique et engager des
         interactions sociales enrichissantes. </div>
        </div>

    
   
      <div className="containerclub1">
            <div className='CLUB'>
            <div className='IMAGECLUB' >
                <img src={MUSIQUE} alt="MUSIQUE"/>
                </div>
                <div>
                <div className="l" >
                <a href='https://www.facebook.com/profile.php?id=61552512991952&mibextid=ZbWKwL' target='_blank'><ion-icon name="logo-facebook"></ion-icon></a>
                <a href='https://www.instagram.com/binary_beats_club_isimm?igsh=b29xc2d6NzE3bnJ0' target='_blank'></a><ion-icon name="logo-instagram"></ion-icon>
                <a href='https://www.linkedin.com/in/binary-beats-club-3156222b2?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><ion-icon name="logo-linkedin"></ion-icon></a>
                </div>
                </div>
            </div>
            <div className='PRESCLUB'>
            <span className='NOMCLUB'>BINARY BEATS</span><br/><br/>
        BINARY BEATS est un club de musique où les étudiants se réunissent pour exprimer leur amour de la musique.
         En participant à des répétitions, des concerts et des événements spéciaux, les membres 
         du club perfectionnent leurs compétences musicales tout en tissant des liens forts avec leurs pairs.
          Que ce soit en jouant d'un instrument, en chantant dans une chorale ou en composant de la musique, 
          ce club offre une expérience enrichissante qui nourrit l'âme et crée des souvenirs inoubliables tout 
          au long du parcours universitaire. </div>
        </div>
    <Footer />
    </div>

  );
}

export default Club;
